export const SET_ITEM_TO_CALENDAR = 'SET_ITEM_TO_CALENDAR';

export const setItemToCalendar = (payload) => ({
  type: SET_ITEM_TO_CALENDAR,
  payload,
});
